import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import * as Yup from "yup"
import formatNumberWithCommas from "components/Common/formatNumberWithCommas"
import {
  Container,
  FormFeedback,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Form,
  Input,
} from "reactstrap"
import Select from "react-select"
import { TextEditor } from "./TextEditor"
import { useFormik } from "formik"
import {
  getRfqDetail,
  getRfqEmailInvitationDetail,
  getVendorListForRfq,
  listActiveVendorType,
  sendRfqEmailInvitationsTovendors,
  vendorListByTypes,
} from "helpers/fakebackend_helper"
import Swal from "sweetalert2"

const SendInvitations = () => {
  const { id } = useParams()
  const [rfqDetail, setRfqDetail] = useState([])
  const [invitations, setRfqInvitationDetail] = useState([])
  const [vendorList, setVendorList] = useState([])
  const navigate = useNavigate()
  const [vendorType, setVendorType] = useState([])
  const [vendorTypeId, setVendorTypeId] = useState([])
  document.title = "Invitations"
  
  const fetchVendorType = async () => {
    try {
      const response = await listActiveVendorType()
      setVendorType(response.data)
    } catch (error) {
      console.error("Error fetching vendor type:", error)
    }
  }
  const changeDateFormat = date => {
    return date?.toString().split("-").reverse().join("-")
  }
  useEffect(() => {
    // Define and execute data fetching functions
    const fetchRfqDetail = async () => {
      try {
        const response = await getRfqDetail(id)
        setRfqDetail(response.data)
      } catch (error) {
        console.error("Error fetching rfq:", error)
      }
    }
    const fetchRfqEmailInvitations = async () => {
      try {
        const response = await getRfqEmailInvitationDetail(id)
        setRfqInvitationDetail(response.data)
      } catch (error) {
        console.error("Error fetching rfq:", error)
      }
    }
    const fetchVendorList = async () => {
      try {
        const response = await getVendorListForRfq(id)
        setVendorList(response.data)
      } catch (error) {
        console.error("Error fetching rfq:", error)
      }
    }
    

    // Call both fetch functions
    fetchRfqDetail()
    fetchRfqEmailInvitations()
    fetchVendorList()
    fetchVendorType()
  }, [id])

  useEffect(()=>{
    const fetchVendorListByType = async () => {
      try {
        const data={
          vendor_type_id:vendorTypeId
        }
         const response = await vendorListByTypes(data)
         setVendorList(response.data)
      } catch (error) {
        console.error("Error fetching rfq:", error)
      }
    }
    fetchVendorListByType()
  },[vendorTypeId])

  const [isChecked, setIsChecked] = useState(true);
  const [modal, setModal] = useState(false)
  const [selectedVendors, setSelectedVendors] = useState([])

  const toggleModal = () => setModal(!modal)

  // const vendorOptions = [
  //   { value: "ABC Supplies", label: "ABC Supplies" },
  //   { value: "XYZ Contractors", label: "XYZ Contractors" },
  //   { value: "LMN Enterprises", label: "LMN Enterprises" },
  // ]

  const vendorOptions = vendorList.map(vendor => ({
    value: vendor.vendor_id,
    label: vendor.vendor_name,
  }))

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      vendor_id: "",
      rfq_id: "",
      subject: "",
      message: "<p></p>",
      send_tendor_doc:"true"
    },
    validationSchema: Yup.object().shape({
      subject : Yup.string().required("Please enter the Subject"),
      vendor_id : Yup.string().required("Vendors are required"),
    }),

    onSubmit: async values => {},
  })
  const fetchEmailDetail = async () => {
    try {
      const response = await getRfqEmailInvitationDetail(id)
      setRfqInvitationDetail(response.data)
    } catch (error) {
      console.error("Error fetching rfq:", error)
    }
  }
  useEffect(() => {
    if (id && validation.values.rfq_id === "") {
      validation.setFieldValue("rfq_id", id)
    }
  }, [id,validation.values.rfq_id])

  const handleVendorBlur = (event) => {
    validation.validateField('vendor_id')
    validation.setFieldTouched('vendor_id', true);
    console.log("touched after blur:", validation.touched); // Log touched *after* setFieldTouched
  };

  const sendInvitations = async () => {
  
    try {
        const loadingSwal = Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
      })
        const sendInvite = await sendRfqEmailInvitationsTovendors(validation.values)
      
        if(sendInvite.status === true){
          loadingSwal.close()
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Invitation sent successfully",
          })
        }
        else {
          loadingSwal.close()
          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Invitation could not be sent",
          })
        }

        fetchEmailDetail()
        setSelectedVendors([])
        toggleModal()
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error?.response?.data?.message || 'An unexpected error occurred',
      });
    }
  }

  useEffect(() => {
    const selectedVendorCommaSeparated = selectedVendors
      .map(vendor => vendor.value)
      .join(",")
    validation.setFieldValue("vendor_id", selectedVendorCommaSeparated)
  }, [selectedVendors])

  const handleChange = (e) => {
    const value = (e.target.checked)
    setIsChecked(value)
    validation.setFieldValue("send_tendor_doc",value?.toString())
    validation.handleChange
  }

  console.log('touched:', validation.touched);
  console.log('errors:', validation.errors);
  console.log('values:', validation.values);
  console.log("vendorTypeId", vendorTypeId);
  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
            <Col lg={12}>
              <CardTitle className="h4 mb-3" style={{ fontSize: "20px" }}>
                <div className="d-flex gap-2 ">
                  <i
                    className="mdi mdi-arrow-left font-size-20"
                    style={{ color: "grey" }}
                    onClick={() => {
                      navigate(-1)
                    }}
                  ></i>
                  Invitations
                </div>
              </CardTitle>
            </Col>
          </Row>
        <Card>
          <CardBody>
            <CardTitle className="fw-bold">RFQ Details</CardTitle>
            <Row>
              <Col md={6}>
                <p>
                  <strong>Project:</strong> {rfqDetail.project_name}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>RFQ Code:</strong> {rfqDetail.rfq_code}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>RFQ Title:</strong> {rfqDetail.rfq_title}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Goods/Services Head:</strong>{" "}
                  {rfqDetail.head_first_name}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Goods/Services Sub-Head:</strong>{" "}
                  {rfqDetail.subhead_first_name}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Budget (Rs):</strong> {rfqDetail.budget}{/*} ? formatNumberWithCommas(rfqDetail.budget) : "NA"*/}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Issue Date:</strong> {rfqDetail.issue_date?changeDateFormat(rfqDetail.issue_date):"--"}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Valid Upto:</strong> {rfqDetail.valid_to}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Total Final Amount:</strong>{" "}
                  {rfqDetail.total_final_amount ? formatNumberWithCommas(rfqDetail.total_final_amount) : "NA"}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Total Remaining Amount:</strong>{" "}
                  {rfqDetail.total_remaining_amount ? formatNumberWithCommas(rfqDetail.total_remaining_amount) : "NA"}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Security Deposit(Percentage of total final amount):</strong>{" "}
                  {rfqDetail.security_deposit_amount ? formatNumberWithCommas(rfqDetail.security_deposit_amount)+"%": "NA"}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Advance Payment Amount:</strong>{" "}
                  {rfqDetail.advance_payment_amount ? formatNumberWithCommas(rfqDetail.advance_payment_amount) : "NA"}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Assigned To:</strong> {rfqDetail.vendor_name}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Current Status:</strong>{" "}
                  {rfqDetail.current_status_name}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Tendor Document:</strong>{" "}
                  <a
                    size="sm"
                    className="d-inline-flex focus-ring py-1 px-2 text-decoration-none border rounded-2"
                    target="_blank"
                    rel="noreferrer"
                    href={rfqDetail.tender_document_viewPath}
                  >
                      View
                  </a>
                </p>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card className="mt-4">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <CardTitle className="fw-bold">Invitations Sent</CardTitle>
              {rfqDetail.assigned_vendor_id===null && (
                <Button
                  color="primary"
                  className="btn-sm mb-2"
                  style={{ marginLeft: "auto" }}
                  onClick={toggleModal}
                >
                  Invite Vendors
                </Button>
              )}
            </div>
            <Table className="table table-striped mb-0" bordered>
              <thead>
                <tr>
                  <th>Vendor Name</th>
                  <th>Vendor Type</th>
                  <th>Invite Sent Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {invitations.length > 0 ? (
                  invitations.map((invite, index) => (
                    <tr key={index}>
                      <td>{invite.vendor_name}</td>
                      <td>{invite.vendor_type_title?invite.vendor_type_title:"--"}</td>
                      <td>{invite.created_at}</td>
                      <td>{invite.status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No invitations sent yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Invite Vendors</ModalHeader>
        <ModalBody>
          <Row>
            <div className="mb-3">
              <Col>
                <div className="mb-3">
                  <Label htmlFor="formrow-vendor-type-Input">Vendor Type*</Label>
                  <select
                    onChange={(e) => {
                      validation.handleChange(e)
                      setVendorTypeId(e.target.value)
                    }}
                    onBlur={validation.handleBlur}
                    name="rfq_vendor_type"
                    placeholder="Enter Your Vendor Type"
                    value={validation.values.rfq_vendor_type}
                    className={`form-select ${
                      validation.touched.rfq_vendor_type &&
                      validation.errors.rfq_vendor_type
                        ? "is-invalid"
                        : ""
                    }`}
                  >
                    {!validation.values.rfq_vendor_type && (
                      <option>Enter Your Vendor Type</option>
                    )}

                    {(vendorType || []).map(item => (
                      <option key={item.id} value={item.id}>
                        {item.vendor_type_title}
                      </option>
                    ))}
                  </select>
                  {validation.touched.rfq_vendor_type &&
                  validation.errors.rfq_vendor_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.rfq_vendor_type}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col>
              <Label>Vendor*</Label>
              <Select
                id="vendor_id"
                name="vendor_id"
                className="mb-2"
                isMulti
                options={vendorOptions}
                value={selectedVendors}
                onBlur={handleVendorBlur}
                invalid={validation.touched.vendor_id && validation.errors.vendor_id==="Vendors are required"}
                onChange={setSelectedVendors}
                placeholder="Select vendors..."
                styles={{
                  menu: provided => ({
                    ...provided,
                    zIndex: 9999,
                    backgroundColor: "white",
                  }),
                  groupHeading: base => ({
                    ...base,
                    color: "#000", // Black text color
                    fontSize: "16px", // Increase font size
                    fontWeight: "bold", // Make it bold
                    padding: "10px 12px", // Add some padding
                    backgroundColor: "#f8f9fa", // Light gray background (optional)
                  }),
                  option: (base, { data, isDisabled, isFocused, isSelected }) => ({
                    ...base,
                    paddingLeft: "16px", // Indent options under group labels
                  }),
                  multiValue: base => ({
                    ...base,
                    backgroundColor: "#bfbdbd", // Dark background color for selected values
                    color: "#fff", // White text color
                  }),
                  multiValueLabel: base => ({
                    ...base,
                    color: "#343a40", // White text color for selected value label
                  }),
                  multiValueRemove: base => ({
                    ...base,
                    color: "#fff", // White color for remove icon (X)
                    ":hover": {
                      backgroundColor: "#343a40", // Darken background on hover
                      color: "#fff", // Keep text color white on hover
                    },
                  }),
                }}
                // styles={{
                //   menu: provided => ({
                //     ...provided,
                //     zIndex: 9999,
                //     backgroundColor: "white",
                //   }),
                // }}
              />
              {(validation.touched.vendor_id && validation.errors.vendor_id==="Vendors are required") && (
              <div style={{color:"#f46a6a", fontSize:"10px", marginTop:"0px"}}>
                {validation.errors.vendor_id}
              </div>
              )}
              </Col>
            </div>
          </Row>
          <Row>
            <div className="mb-3">
              <Col>
                <Label>Subject*</Label>
                <Input
                  type="text"
                  name="subject"
                  className="form-control mb-2"
                  id="subject"
                  placeholder="Enter Subject"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.subject || ""}
                  invalid={
                    validation.touched.subject && validation.errors.subject
                      ? true
                      : false
                  }
                ></Input>
                <FormFeedback type="invalid">
                  {validation.errors.subject}
                </FormFeedback>
              </Col>
            </div>
          </Row>
          <Row>
            <Col sm="6">
              <div className="mb-3">
                  <Label className="form-check-label" htmlFor="isActive">
                    Attach Tender Document?
                  </Label>
                  <div className="form-check form-switch form-switch-md mt-2">
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    id="send_tendor_doc"
                    name="send_tendor_doc"
                    checked={isChecked}
                    onChange={(e)=>handleChange(e)}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <Label>Message:</Label>
              <Form method="post">
                <TextEditor
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  setFieldValue={val =>
                    validation.setFieldValue("message", val)
                  }
                  value={validation.values.message}
                />
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={sendInvitations}>
            Send Invitations
          </Button>{" "}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default SendInvitations
